import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import {
  ATTRACT_SOURCE_URL,
  HIRE_ANALYTICS_URL,
  TRACK_COLLABORATE_URL
} from '~/core/constants/url'
import LPContainer from './LPContainer'
import SeeMoreLink from './components/SeeMoreLink'
import SectionContainer from './components/section/SectionContainer'

const FeatureOverviewSection: FC = () => {
  const { t } = useTranslation()

  return (
    <SectionContainer
      title="all_features:features_overview_title"
      tagLabel="all_features:features_overview_tag"
      tagColor="bg-blue-100 text-blue-800"
      className="pb-5 mt-[64px] mb-0 desktop:mt-[140px] desktop:mb-0">
      <LPContainer className="mt-6 space-y-10 px-0 tablet:px-4">
        <div className="mt-8 tablet:mt-12 flex flex-col gap-3 tablet:gap-5">
          <div className="flex flex-col tablet:flex-row gap-3 tablet:gap-5">
            {/* attract & source */}
            <div className="flex-1 bg-gray-100 border border-transparent rounded-xl pt-6 tablet:px-8">
              <div className="font-medium text-lg text-gray-900 text-center">
                {t('all_features:attract_and_source')}
              </div>
              <div className="my-1 text-base text-center text-gray-700 px-8">
                {t('all_features:attract_and_source_description')}
              </div>
              <SeeMoreLink
                label={t('lp:learn_more')}
                link={ATTRACT_SOURCE_URL}
              />
              <picture>
                <source
                  media="(min-width: 768px)"
                  srcSet="/img/feature/lp/features-overview__attract-source-desk.png"
                />
                <source
                  media="(max-width: 767px)"
                  srcSet="/img/feature/lp/features-overview__attract-source-mweb.png"
                />
                <img alt="Attract & Source" className="mt-3 tablet:mt-8" />
              </picture>
            </div>
            {/* track & collaborate */}
            <div className="flex-1 bg-gray-100 border border-transparent rounded-xl pt-6 tablet:px-8">
              <div className="font-medium text-lg text-gray-900 text-center">
                {t('all_features:track_and_collaborate')}
              </div>
              <div className="my-1 text-base text-center text-gray-700 px-8">
                {t('all_features:track_and_collaborate_description')}
              </div>
              <SeeMoreLink
                label={t('lp:learn_more')}
                link={TRACK_COLLABORATE_URL}
              />
              <picture>
                <source
                  media="(min-width: 768px)"
                  srcSet="/img/feature/lp/features-overview__track-collaporate-desk.png"
                />
                <source
                  media="(max-width: 767px)"
                  srcSet="/img/feature/lp/features-overview__track-collaporate-mweb.png"
                />
                <img alt="Attract & Source" className="mt-3 tablet:mt-8" />
              </picture>
            </div>
          </div>
          {/* hire & analytic */}
          <div className="bg-gray-100 border border-transparent rounded-xl pt-6 tablet:px-8 flex flex-col gap-5 tablet:flex-row">
            <div className="w-full tablet:w-2/5 flex flex-col items-center tablet:items-start">
              <div className="font-medium text-lg text-gray-900 text-center tablet:text-left">
                {t('all_features:hire_and_analytic')}
              </div>
              <div className="my-1 text-base text-center tablet:text-left text-gray-700 px-8">
                {t('all_features:hire_and_analytic_description')}
              </div>
              <SeeMoreLink
                label={t('lp:learn_more')}
                link={HIRE_ANALYTICS_URL}
              />
              <picture>
                <source
                  media="(min-width: 768px)"
                  srcSet="/img/feature/lp/features-overview__hire-analytic-1-desk.png"
                />
                <source
                  media="(max-width: 767px)"
                  srcSet="/img/feature/lp/features-overview__hire-analytic-mweb.png"
                />
                <img
                  alt="Hire & Analytic"
                  className="mt-3 tablet:mt-8 w-full tablet:w-8/12 mx-auto"
                />
              </picture>
            </div>
            <div className="hidden tablet:flex w-3/5 flex-col justify-between">
              <picture>
                <source
                  media="(min-width: 768px)"
                  srcSet="/img/feature/lp/features-overview__hire-analytic-2-desk.png"
                />
                <img alt="Hire & Analytic" className="mt-3 tablet:mt-[22px]" />
              </picture>
            </div>
          </div>
        </div>
      </LPContainer>
    </SectionContainer>
  )
}

export default FeatureOverviewSection
